// extracted by mini-css-extract-plugin
module.exports = {"mark":"mark_2n2TJ","iframeBox":"iframeBox_20zvi","closeImg":"closeImg_3UKMT"};